import Vue from 'vue'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'

Vue.directive('preview', {
    bind(el) {
        // 查找所有 img 子元素
        const images = el.querySelectorAll('img')
        console.log(images);
        
        if (images.length === 0) {
            console.warn('v-preview 指令绑定的容器中没有 <img> 元素')
            return
        }

        // 创建 Viewer 实例
        const viewer = new Viewer(el, {
            url: 'src', // 使用 <img data-original="xxx"> 指定大图地址
            inline: false,
            button: true,
            navbar: true,
            title: true,
            toolbar: true,
            tooltip: true,
            movable: true,
            zoomable: true,
            rotatable: true,
            scalable: true,
            transition: true,
            fullscreen: true,
            keyboard: true
        })

        // 保存 viewer 实例用于解绑
        el._viewerInstance = viewer
    },
    unbind(el) {
        if (el._viewerInstance) {
            el._viewerInstance.destroy()
            el._viewerInstance = null
        }
    }
})